module.exports = __webpack_public_path__ + "static/media/CONTATO.d459c36a.png";